export default "__VITE_ASSET__02f1bc2a__"